import {URLS} from 'fire-wind-water';

const config = window.stemplateConfig || {};
export const settings = {
  isPreview: config.isPreview || false,
  tenantId: config.tenantId || null,
  schemaId: config.schemaId || null,
  customFormId: config.customFormId || null,
  siteId: config.siteId || null,
  instanceId: config.instanceId || null,
  category: config.category || null,
  channel_code: URLS.getURL('pk_source')
};